import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Category } from 'projects/qcloud-models/category/category.model';
import { timeout } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';
import { CategoryGroup } from 'projects/qcloud-models/category/category-group.model';
import { AxxonIntelectIntegrationCategoryFacilityCode } from 'projects/qcloud-models/integration/axxon-intelect-integration';
import { AmmsCode, CodeType } from 'projects/qcloud-models/integration/amms-code';
import { AmmsCategoryMap } from 'projects/qcloud-models/integration/amms-category-mapping';
import { AmmsMappedReservation } from 'projects/qcloud-models/integration/amms-mapped-reservation';

const DEFAULT_TIMEOUT = 30000;

@Injectable({
    providedIn: 'root'
})
export class TaxIntegrationClientService {

    appBase: string;

    constructor(private http: HttpClient, private authService: AuthService) { }

    public setAppBase(appBase: string) {
        this.appBase = appBase;
    }

    getAppointment(appointmentId: string, phoneNumber: string): Observable<any> {
        return this.http.get(this.appBase +
            `api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/tax-integration?appointmentId=${appointmentId}&phoneNumber=${phoneNumber}`)
            .pipe(timeout(DEFAULT_TIMEOUT));
    }

    confirmAppointment(appointmentId: string, phoneNumber: string): Observable<any> {
        return this.http.post(this.appBase +
            `api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/tax-integration?appointmentId=${appointmentId}&phoneNumber=${phoneNumber}`, {})
            .pipe(timeout(DEFAULT_TIMEOUT));
    }

    getTaxIntegrationMaps(callback: (data: any) => any, onError: () => any) {
        const url = `${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/tax-integration/maps`;
        this.http.get(url)
            .pipe(timeout(DEFAULT_TIMEOUT))
            .subscribe(callback, onError);
    }

    replaceTaxIntegrationMaps(maps: any[], callback: (data: any) => any, onError: () => any) {
        const url = `${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/tax-integration/maps`;
        this.http.put(url, maps)
            .pipe(timeout(DEFAULT_TIMEOUT))
            .subscribe(callback, onError);
    }

    getConfig(callback: (data: any) => any, onError: () => any) {
        const url = `${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/tax-integration/config`;
        this.http.get(url)
            .pipe(timeout(DEFAULT_TIMEOUT))
            .subscribe(callback, onError);
    }

    addOrUpdateConfig(config: any, callback: (data: any) => any, onError: () => any) {
        const url = `${this.appBase}api/${this.authService.getSystemId()}/${this.authService.getLocationId()}/tax-integration/config`;
        this.http.post(url, config)
            .pipe(timeout(DEFAULT_TIMEOUT))
            .subscribe(callback, onError);
    }
}
